import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VeeValidate, { Validator } from 'vee-validate';  // Add { Validator } here
import KeaAuth from "../_shared/kea-auth.js";
import RouterView from "./router.vue";
import "ie-string-startswith-polyfill"; // ES6 Polyfill
import "es6-object-assign/auto"; // ES6 Promises Polyfill for IE11 support
import acConstants from "../_shared/constants.js";
import CreateForm from "./create.vue";
import UnboundForm from "./unbound.vue";
import MarketingForm from "./marketing.vue";
import OutlookForm from "./outlook.vue";
import ClaimLog from "./claim-log/claim-log.vue";
import "es6-promise/auto"; // ES6 Promises Polyfill for IE11 support
import Loading from 'vue-loading-overlay';
import Snotify from 'vue-snotify/vue-snotify.min.js';
import _ from 'lodash';
import { TE_ENTRY_OPTIONS } from '../_shared/constants';

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VeeValidate, {
    events: ''
});
Vue.use(Loading);
Vue.use(Snotify, {
    toast: {
        position: 'centerTop',
    }
});
Vue.use(acConstants);

Vue.config.devtools = false;
Vue.config.productionTip = false;

Vue.component("time-expense", RouterView);

// redirect the browser to the login page if a login page is returned by axios
KeaAuth.intercept401Errors();

const routes = [
    {
        path: "",
        component: RouterView,
        children: [
            { path: "/unbound", component: UnboundForm },
            { path: "/marketing", component: MarketingForm },
            { path: "/outlook", component: OutlookForm },
            { path: "/marketing/:action", component: MarketingForm, props: true },
            { path: "/create", component: CreateForm },
            { path: "/create/:action", component: CreateForm, props: true },
            { path: "/", component: ClaimLog },
        ]
    }
];

const router = new VueRouter({
    routes
});

const store = new Vuex.Store({
    state: {
        branchId: null,
        fileId: null,
        kaClaimNumber: "",
        insuredCompany: "",
        isValidFileId: false,
        isAdmin: false,
        currentUser: "",
        currentUserBranchId: null,
        defaultUser: "",
        claimAdjuster: "",
        userTimezone: "",
        folderUrl: "",
        isClosed: false,
        isWholeFoodsParentIncident: false,
        startPage: 1,
        reviveSession: false,
        editId: 0,
        lastEditId: 0,
        activityCodes: [],
        lastReportNumber: 0,
        reportCycle: 0,
        abeyanceOffset: 0,
        timeEntry: {
            id: null,
            branchId: null,
            fileId: null,
            insuredCompany: "",
            date: new Date(new Date().setHours(0, 0, 0, 0)),
            time: new Date(new Date()),
            timezone: "",
            username: "",
            activityCode: "",
            hours: null,
            units: null,
            dollars: null,
            isBillable: "Yes",
            sendEmail: "No",
            emailTo: null,
            attachInvoice: "Yes",
            invoiceId: null,
            isMultiInvoice: false,
            isSameSubscriberInvoices: true,
            comment: "",
            hasFollowup: false,
            actionItem: "",
            followupDate: null,
            noteText: "",
            followupAdjuster: "",
            emailToCheckboxes: [],
            isMarketingEvent: "No",
            marketingLocationId: null,
            marketingContactId: null,
            marketingContactLabel: "",
            isNewTransportation: true,
            relatedToTeId: null,
            activityCodeType: 0,
            teEntryOption: TE_ENTRY_OPTIONS.BUILDTIME,
            activityCodeAction: null,
            activityCodeTarget: null,
            activityCodeRole: null
        },
        searchFilter: {
            searchText: "",
            startDate: null,
            endDate: null,
            showReversed: false,
            showClerical: true,
            sortDirection: "DESC",
            pageSize: 50,
            expandNotes: false
        },
        fileToBeAudited: false
    },
    getters: {
        isEditForm: state => {
            return state.editId !== 0;
        },
        restrictedEditMode: state => {
            let activity = _.find(state.activityCodes, function (a) { return a.code === state.timeEntry.activityCode; });
            return activity && activity.codeType === 2 && state.editId !== 0 && (state.timeEntry.sendEmail !== 'No' || (state.timeEntry.activityCode === 'AR' && state.timeEntry.relatedToTeId != null));
        },
        nonEmailEditMode: state => {
            let activity = _.find(state.activityCodes, function (a) { return a.code === state.timeEntry.activityCode; });
            return state.editId !== 0 && ((!activity || activity.codeType !== 2) || (state.timeEntry.sendEmail === 'No' && state.timeEntry.relatedToTeId === null));
        },
        selectedActivity: state => {
            let activity = _.find(state.activityCodes, function (a) { return a.code === state.timeEntry.activityCode; });
            return activity;
        },
        isEmailActivity: state => {
            let activity = _.find(state.activityCodes, function (a) { return a.code === state.timeEntry.activityCode; });
            return activity && activity.codeType === 2;
        }
    }
});

// Add custom validator for multiple emails
Validator.extend('emails', {
    validate: value => {
        if (!value || value.trim() === '') {
            return true; // Allow empty if not required
        }

        // Split by semicolon or comma and trim whitespace
        const emails = value.split(/[;,]/).map(email => email.trim()).filter(email => email !== '');

        // Email regex pattern
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Check if all parts are valid emails
        return emails.every(email => emailRegex.test(email));
    },
    getMessage: field => `The ${field} field must contain valid email addresses separated by commas or semicolons.`
});

global.vm = new Vue({
    el: "#timeExpenseContainer",
    router: router,
    store: store
});